'use strict'
import _ from 'lodash'
import api from '../api'
import * as types from '../types'

// 表单验证函数放在这，保证全局可用
// 考虑到某些时候可能需要修改state，也许放在actions而不是一般函数是个好选择？
// 某些请求需要修改route和引用token，初定在params传入，sync获取不能
export default {
  actions: {
    [types.VERIFY_CELLPHONE] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (_.trim(value) === '') {
        cb(new Error('手机号码不能为空'))
        return
      }

      if (_.isNaN(Number(value)) || !/^1[345789]\d{9}$/.test(value)) {
        cb(new Error('手机号码格式有误'))
        return
      }

      if (value.length !== 11) {
        cb(new Error('手机号码必须为11位'))
        return
      }
      cb()
      // commit(types.EMPTY_MUTATION, params)
    },
    [types.VERIFY_LOGIN_PASSWORD] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '' || value === undefined) {
        cb(new Error('登录密码不能为空'))
        return
      }

      if (value.length < 8 || value.length > 16) {
        cb(new Error('登录密码位数必须为8到16位以内'))
        return
      }
      cb()
      // commit(types.EMPTY_MUTATION, params)
    },
    [types.VERIFY_LOGIN_VERIFICATION_CODE] ({commit, getters}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error('验证码不能为空'))
        return
      }

      if (_.isNaN(Number(value))) {
        cb(new Error('验证码格式有误'))
        return
      }

      return api.validateImageVerificationCode({
        token: getters[types.GET_USER].token,
        validCode: value
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          cb()
        } else {
          cb(new Error('验证码有误'))
        }
        return res
      })
    },
    [types.VERIFY_REGISTER_PASSWORD] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error('密码不能为空'))
        return
      }
      if (value.length < 8 || value.length > 16) {
        cb(new Error('密码位数必须为8到16位以内'))
        return
      }
      if (/^\d{8,16}$|^[a-zA-Z]{8,16}$|^\W{8,16}$/.test(value)) {
        cb(new Error('密码必须为英文字母、数字、字符的两两组合'))
        return
      }
      // 现在不需要做这个匹配了
      // if (/(.)\1{4,}/g.test(value)) {  // 有4个以上重复的字符就视为简单
      //   cb(new Error('登录密码过于简单'))
      //   return
      // }
      cb()
    },
    // [types.VALIDATE_SMS_VERIFICATION_CODE] ({commit}, params) {},
    [types.VERIFY_MUST_CHECKED] ({commit}, params) {
      const cb = params.callback
      if (params.value === false) {
        cb(new Error(params.rules.message))
      } else {
        cb()
      }
    },
    [types.VERIFY_PASSWORD_VALID] ({commit, getters}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error(params.rules.message ? params.rules.message : '旧密码不能为空'))
        return
      }

      return api.validateOldLoginPassword({
        token: getters[types.GET_USER].token,
        password: value
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          cb()
        } else {
          cb(new Error('密码填写错误'))
        }
        return res
      })
    },
    [types.VERIFY_CHN_NAME] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error('姓名不能为空'))
        return
      }
      if (!(/^[\u4E00-\u9FFF]+$/.test(value))) {
        cb(new Error('姓名必须为中文字符'))
        return
      }
      if (value.length > 30) {
        cb(new Error('姓名长度不能超过30'))
        return
      }
      cb()
    },
    [types.VERIFY_ID_CARD_NUM] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (_.trim(value) === '') {
        cb(new Error('身份证号码不能为空'))
        return
      }
      if (_.trim(value).length < 18) {
        cb(new Error('必须为18位身份证号'))
        return
      }
      if (!(/^[1-9]{1}\d{14}$|^[1-9]{1}\d{16}(\d|[xX])$/.test(value))) {
        cb(new Error('身份证号码格式错误'))
        return
      }
      cb()
    },
    [types.VERIFY_BANKCARD_NUM] ({commit}, params) {
      const value = params.value.replace(/\s/g, '')
      const cb = params.callback
      if (value.trim() === '') {
        cb(new Error('请输入开户账户'))
      } else if (_.isNaN(Number(value))) {
        cb(new Error('请输入正确的银行卡账户号码'))
      } else if (value.length < 12) {
        cb(new Error('银行卡账户号码不能小于12位'))
      } else if (value.length > 30) {
        cb(new Error('银行卡账户号码不能小于30位'))
      } else {
        cb()
      }
    },
    [types.VERIFY_MUST_SELECTED] ({commit}, params) {
      const cb = params.callback
      if (params.value === '') {
        cb(new Error(params.rules.message))
      } else {
        cb()
      }
    },
    [types.VERIFY_ENTERPRISE_ORGANIZING_NUMBER] ({commit}, params) {
      const cb = params.callback
      if (_.trim(params.value) === '') {
        cb(new Error('组织机构代码证号不能为空'))
      } else if (!/\d{8}-\w{1}/g.test(params.value)) {
        cb(new Error('组织机构代码证号为18位数字组成'))
      } else {
        cb()
      }
    },
    [types.VERIFY_SOCIAL_CREDIT_CODE] ({commit}, params) {
      const cb = params.callback
      if (_.trim(params.value) === '') {
        cb(new Error('社会信用代码号不能为空123'))
      } else if (!/\w{20}/g.test(params.value)) {
        cb(new Error('社会信用代码号为20位数字和英文字母组成'))
      } else {
        cb()
      }
    },
    [types.VERIFY_ENTERPRISE_NUMBER] ({commit}, params) {
      const cb = params.callback
      if (_.trim(params.value) === '') {
        cb(new Error('营业执照号不能为空'))
      } else {
        cb()
      }
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/vuex/modules/form.js